export const IMAGE_WIDTH = 562;
export const IMAGE_HEIGHT = 562;
export const IMAGE_EXTENDED = 1000;
export const BASE_IMAGE = '/images/base.png';
export const API_URL = 'https://goons-metadata.herokuapp.com/goon';
export const PROXY_URL = 'http://173.249.9.67:3001/?url=';
export const PROGRESS_INFO = "Generating gifs can take a while, hang in there..."; 